import { Stack, Switch, Typography } from '@mui/material';
import { FC } from 'react';

import { langSwitchContainerSx } from './styles';

interface ILanguageSwitcherProps {
  language: string;
  onChange: (value: 'ru' | 'en') => void;
}

// Компонент для смены языка
export const LanguageSwitcher: FC<ILanguageSwitcherProps> = ({ language, onChange }) => {
  const renderContent = () => (
    <Stack sx={langSwitchContainerSx} direction='row' spacing={2} color='secondary.main'>
      <Typography>Ru</Typography>
      <Switch checked={language === 'en'} onChange={() => onChange(language === 'ru' ? 'en' : 'ru')} />
      <Typography>En</Typography>
    </Stack>
  );

  return renderContent();
};
